import { Grid, TextField, Box, Typography, Card } from "@mui/material";
import { boxSize } from "utils/apis";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";

const PedidosFormFields = ({ formik, setFieldValue }) => {
  const handleChangeDate = (value, name) => {
    setFieldValue(name, moment(value).format("YYYY-MM-DD"));
  };
  return (
    <Box sx={{ height: boxSize }}>
      <Grid container spacing={4}>
        {/* CARD IZQUIERDA */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 3,
              backgroundColor: "white",
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            <Typography variant="h6" sx={{ mb: 2 }}>
              Información del Pedido
            </Typography>

            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="codigo"
                  name="codigo"
                  label="Código"
                  value={formik.values.codigo}
                  onChange={formik.handleChange}
                  error={formik.touched.codigo && Boolean(formik.errors.codigo)}
                />
              </Grid>

              <Grid item xs={12}>
                <LocalizationProvider
                  dateAdapter={AdapterMoment}
                  adapterLocale="es-mx"
                >
                  <DatePicker
                    name="fechaCreacion"
                    label="Fecha de Creación"
                    value={moment(formik.values.fechaCreacion) || moment()}
                    closeOnSelect
                    sx={{ width: "100%" }}
                    slotProps={{ textField: { variant: "outlined" } }}
                    showDaysOutsideCurrentMonth
                    disableHighlightToday
                    onChange={(value) =>
                      handleChangeDate(value, "fechaCreacion")
                    }
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12}>
                <LocalizationProvider
                  dateAdapter={AdapterMoment}
                  adapterLocale="es-mx"
                >
                  <DatePicker
                    name="fechaEntrega"
                    label="Fecha de Entrega (Mes del Pedido)"
                    value={moment(formik.values.fechaEntrega) || moment()}
                    closeOnSelect
                    sx={{ width: "100%" }}
                    slotProps={{ textField: { variant: "outlined" } }}
                    showDaysOutsideCurrentMonth
                    disableHighlightToday
                    onChange={(value) =>
                      handleChangeDate(value, "fechaEntrega")
                    }
                  />
                </LocalizationProvider>
              </Grid>

              <Grid item xs={12}>
                <LocalizationProvider
                  dateAdapter={AdapterMoment}
                  adapterLocale="es-mx"
                >
                  <DatePicker
                    name="fechaEstimadaTermino"
                    label="Fecha en Fábrica (APT)"
                    value={
                      moment(formik.values.fechaEstimadaTermino) || moment()
                    }
                    closeOnSelect
                    sx={{ width: "100%" }}
                    slotProps={{ textField: { variant: "outlined" } }}
                    showDaysOutsideCurrentMonth
                    disableHighlightToday
                    onChange={(value) =>
                      handleChangeDate(value, "fechaEstimadaTermino")
                    }
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Card>
        </Grid>

        {/* CARD DERECHA */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              p: 3,
              backgroundColor: "white",
              borderRadius: 2,
              boxShadow: 3,
            }}
          >
            <Typography variant="h6" sx={{ mb: 2 }}>
              Datos Adicionales
            </Typography>

            <Grid container spacing={2} alignItems="center">
              {/* Campo Porcentaje */}
              <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                <TextField
                  fullWidth
                  id="percentage"
                  name="percentage"
                  label="Porcentaje Extra"
                  type="number"
                  value={formik.values.percentage}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.percentage &&
                    Boolean(formik.errors.percentage)
                  }
                  helperText="Indica el porcentaje extra a incluir"
                  InputProps={{
                    inputProps: {
                      style: { textAlign: "right", fontSize: 20 },
                    },
                  }}
                />
                <Typography
                  variant="h5"
                  sx={{
                    ml: 1,
                    alignSelf: "flex-start",
                    mt: 2.5,
                  }}
                >
                  %
                </Typography>
              </Grid>

              {/* Número de Pedido */}
              <Grid item xs={6} sx={{ mt: -2.5 }}>
                <TextField
                  fullWidth
                  type="number"
                  id="number"
                  name="number"
                  label="Número de Pedido"
                  value={formik.values.number}
                  onChange={formik.handleChange}
                  InputProps={{
                    inputProps: {
                      style: { textAlign: "right", fontSize: 20 },
                    },
                  }}
                  error={formik.touched.number && Boolean(formik.errors.number)}
                  helperText={formik.touched.number && formik.errors.number}
                />
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
export default PedidosFormFields;
